import { all } from 'redux-saga/effects'
import powerBIReportsSaga from './powerBIReports'
import powerBIReportSaga from './powerBIReport'

function* analyticsSaga() {
  yield all([powerBIReportsSaga(), powerBIReportSaga()])
}

export default analyticsSaga
